<template>
  <LoadingSpinner v-if="!cotizacion || !agente || !cotizacionDetalle" />
  <section class="col-md-11 mx-auto" v-else>
    <section class="p-md-5">
      <div class="row">
        <div class="p-3 pt-4 pb-5 card-header bg-transparent">
          <div
            class="d-flex flex-column flex-lg-row justify-content-between align-items-center gap-2"
          >
            <router-link
              :to="{
                name: 'cotizacion-unidades-nueva',
              }"
            >
              <ArgonButton size="sm" color="dark" icon="ri-add-line"
                >Nueva cotización</ArgonButton
              >
            </router-link>
            <ArgonButton
              size="sm"
              color="dark"
              icon="ri-file-copy-line"
              @click="copiarUrlAprobacion"
              >Copiar url aprobación</ArgonButton
            >
            <a
              class="btn btn-light btn mb-0 d-flex flex-row align-items-center justify-content-center gap-2 btn-sm"
              :href="`${urlEndpoint}public/cotizaciones/unidad/${cotizacion.token}/preview?download=true`"
              target="_blank"
              ><i class="ri ri-download-line me-2"></i>Descargar formato</a
            >
          </div>
        </div>
      </div>
      <iframe
        :src="`${urlEndpoint}public/cotizaciones/unidad/${token}/preview#toolbar=0`"
        title="PDF embebido"
        allowfullscreen
        class="w-100 border rounded"
        style="height: 95vh"
      ></iframe>
    </section>
  </section>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useCotizacionUnidad } from "@/composables/useCotizacionUnidad";
import LoadingSpinner from "@/components/LoadingComponent.vue";
import ArgonButton from "@/components/ArgonButton.vue";

const {
  agente,
  copiarUrlAprobacion,
  cotizacion,
  cotizacionDetalle,
  getById,
  token,
  urlEndpoint,
} = useCotizacionUnidad();

onMounted(async () => {
  await getById();
});
</script>

<style scoped>
.bg-dark {
  background: #000 !important;
}

input {
  background-color: transparent;
  border: none;
}
</style>
